import React, { useState }   from "react";
import './ObraDisponible.css';
import Modal from './Modal.js';

export default function ObraDisponible() {

    const [count, setCount] = useState(0);
    const [show, setShow]   = useState(false);
    const [img, setImg]     = useState("");
    const  hideModal        = () => setShow(false);
    let counter = 0; 

    // Src de galerias

    const [img1, setImg1] = useState("/izquierda.jpg");
    const [img2, setImg2] = useState("/derecha.jpg");
    const [img3, setImg3] = useState("/1.jpg");
    const [img4, setImg4] = useState("/2.jpg");
    const [img5, setImg5] = useState("/4.jpg");
    const [img6, setImg6] = useState("/5.jpg");


    function showModal(funcImg){
        setShow(true);
        setImg(funcImg); 
    }

    const jsonContenedorUno = {
        img1: "",
        img2: "",
    };

    const srcContenedorUno = "";





    React.useEffect(() => {  

            setInterval(() => {
            setCount(counter = counter + 1);

            if(counter > 12){
                setCount(counter = 1);
                
             }
            
            if(counter < 4){
            
                setImg1("/izquierda.jpg");
                setImg2("/derecha.jpg");
                setImg3("/1.jpg");
                setImg4("/2.jpg");
                setImg5("/4.jpg");
                setImg6("/5.jpg");


             } else if (counter > 4 && counter < 8){
                
                setImg1("/1.jpg");
                setImg2("/3.jpg");
                setImg3("/4.jpg");
                setImg4("/5.jpg");
                setImg5("/izquierda.jpg");
                setImg6("/derecha.jpg");


             } else if (counter > 8){
               
                setImg1("/4.jpg");
                setImg2("/6.jpg");
                setImg3("/5.jpg");
                setImg4("/1.jpg");
                setImg5("/derecha.jpg");
                setImg6("/6.jpg");

                              
             }     
                
                console.log(counter);
    
            }, 1000);
     },[])

     const classImg = "imagen elemento 1";

    return (
        <div className='contenedor'>
            <div className='galeria'>
                <div className='imagen elemento 1 fade'  onClick={() => showModal(img1)}>
                    <img className = 'contorno'
                        src={process.env.PUBLIC_URL + img1} alt="No se pudo cargar la imagen">
                    </img>
                </div>
                <div className='imagen elemento 2 fade' onClick={() => showModal(img2)}>
                    <img 
                        className = 'contorno' 
                        src={process.env.PUBLIC_URL + img2} alt="No se pudo cargar la imagen">
                    </img>
                </div>
                <div className='imagen elemento 3 fade' onClick={() => showModal(img3)}>
                    <img className = 'contorno' 
                        src={process.env.PUBLIC_URL + img3} alt="No se pudo cargar la imagen">
                    </img>
                </div>
                <div className='imagen elemento 4 fade ' onClick={() => showModal(img4)}>
                    <img className = 'contorno' 
                        src={process.env.PUBLIC_URL + img4} alt="No se pudo cargar la imagen">
                    </img>
                </div>
                <div className='imagen elemento 5 fade' onClick={() => showModal(img5)}>
                    <img className = 'contorno' 
                        src={process.env.PUBLIC_URL + img5} alt="No se pudo cargar la imagen">
                    </img>
                </div>
                <div className='imagen elemento 6 fade' onClick={() => showModal(img6)}>
                    <img className = 'contorno' 
                        src={process.env.PUBLIC_URL + img6} alt="No se pudo cargar la imagen">
                    </img>
                </div>
            </div>
            <Modal 
                show={show} 
                handleClose={hideModal} 
                image={img}>
            </Modal>
        </div>
    );
}